module.exports = __webpack_public_path__ + "img/2f023088a266e1cca5452da5005afbb3-default-fiat.png";